<template>
  <div class="sub-wrap">
    <header class="header-box">
      <div class="top"></div>
      <div class="opera">
        <ul class="menu-list">
          <li>首页</li>
          <li>我要办税</li>
          <li>我要查询</li>
          <li>公众服务</li>
          <li>地方特色</li>
        </ul>

        <div class="grow"></div>

        <el-input
            placeholder="请输入关键词"
            readonly
            style="width: 150px;margin-right: 10px;"
            suffix-icon="Search"
        />
        <div
            class="right-icon"
        >
          <el-icon color="#FFFFFF" size="30">
            <User/>
          </el-icon>
        </div>
      </div>
    </header>

    <div class="page-content">
      <div class="page-wrap">
        <div class="main-box">
          <div class="left-main">
            <div class="left-top show-shadow">
              <div style="display: inline-flex; align-items: center">
                <p style="width: 230px; line-height: 24px; font-weight: 600; color: #333">{{staticConfig.companyName}}</p>
                <div style="display: inline-flex">
                  <span class="atext1">A</span>
                  <span class="atext2">级纳税人</span>
                </div>
              </div>
              <div style="width: 100%; display: inline-flex; align-items: center; justify-content: space-between; line-height: 24px; font-size: 12px">
                <span> 91320214323988856G</span>
                <span>本月征期已结束还有*天</span>
              </div>
            </div>
            <div class="left-bottom show-shadow">
              <div class="list-head">
                <span>我的提醒</span>
              </div>
            </div>
          </div>

          <div class="right-main">
            <p>我的待办</p>
            <el-tabs :modelValue="activeName1">
              <el-tab-pane label="本期应申报" name="first">
                <el-table :data="tableData" height="250">
                  <el-table-column label="事项名称" prop="sqbzl" align="center" />
                  <el-table-column label="办理期限" prop="sbqx" align="center" width="120" />
                  <el-table-column label="标签状态" prop="status" align="center" width="120">
                    <template #default="{ row }">
                      <el-tag v-show="row.status == 1" type="success">已申报</el-tag>
                      <el-tag v-show="row.status != 1" type="warning">未申报</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center" width="120">
                    <template #default="{ row }">
                      <div>
                        <el-button type="primary" link @click="startFill(row)">填写申报表</el-button>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane label="待签收文书" name="second" />
              <el-tab-pane label="风险疑点" name="third" />
              <el-tab-pane label="其它" name="fourth" />
            </el-tabs>
          </div>
        </div>

        <div class="collection-box">
          <div class="collection-content">
            <el-tabs v-model="activeName2">
              <el-tab-pane label="热门服务" name="first">
                <div style="position: relative">
                  <div class="main" :style="{ left: '-' + slides1 * 1184 + 'px' }">
                    <div class="item" v-for="(item, index) in data">
                      <div class="item-content">
                        <div class="item-img-box">
                          <img :src="fn(item.icon)" alt="#" />
                        </div>
                        <p class="item-info">{{ item.title }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="leftbtn" @click="slides1 = 0">
                    <el-icon><ArrowLeft /></el-icon>
                  </div>
                  <div class="rightbtn" @click="slides1 = 1">
                    <i class="el-icon-arrow-right"></i>
                    <el-icon><ArrowRight /></el-icon>
                  </div>
                  <div class="footerscsc">
                    <div class="box" @mouseover="slides1 = 0" :style="{ background: slides1 == 0 ? '#649cf5' : '#ccc' }"></div>
                    <div class="box" @mouseover="slides1 = 1" :style="{ background: slides1 == 1 ? '#649cf5' : '#ccc' }"></div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="我的收藏" name="second"> </el-tab-pane>
            </el-tabs>
          </div>
        </div>

        <div class="cjbs-box"></div>

        <div class="digital-box"></div>
        <div class="declaration-box"></div>
        <div class="delated-box"></div>
      </div>

      <div class="index-footer-box">
        <div class="copyright">
          <div style="width: 100%; display: inline-flex; align-items: center; justify-content: center">
            <img src="https://static.rhkj.com/renhe_fe/other/reportTax/copyright.png" alt="#" style="height: 80px; object-fit: cover" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {reportTaxDateConfig} from "@/views/examCenter/reportTax/reportTaxStaticConfig.js";

const emit = defineEmits(['startFill', 'yhs']);

const props = defineProps({
  currentQa: {
    // 当前题目信息对象
    required: true,
    type: Object,
  },
});

const taxQuestionType = computed(() => {
  switch (props.currentQa.sonQueType) {
    case '21':
      return 1; // 增值税--小规模
    case '26': // 企税--一般
    case '22': // 企税--小规模
    case '2201':
    case '2601':
      return 2;
    case '23': // 增值税--一般
      return 3;
    case '24': // 印花税--小规模
    case '25': // 印花税--一般
      return 4
    case '27': // 财务报表报送（季度）（一般纳税人）
      return 5
    case '28': //财务报表报送（季度）（小规模纳税人）
      return 5
    case '29': // 汇算清缴-财务报表报送
      return 29
    case '201': //汇算清缴-企业所得税年度申报
      return 201
    default:
      throw new Error('不支持的类型');
  }
});

const tableData = ref([]);

const {staticConfig} = reportTaxDateConfig(props.currentQa)

onMounted(() => {
  const taxDataAll = (props.currentQa?.solution && JSON.parse(props.currentQa.solution)) || null;
  const status = taxDataAll?.status || 0;

  if (taxQuestionType.value == 3) {
    tableData.value = [
      {
        id: '5da08277651d4c848a399e8a32061b2d',
        sqbzl: '增值税及附加税费申报(一般纳税人适用)',
        sbqx: staticConfig.finishDeadline,
        status: status,
      },
    ];
  } else if (taxQuestionType.value == 2) {
    tableData.value = [
      {
        id: 'e7c2a427da26465cbbc243e0e488f83c',
        sqbzl: '居民企业（查账征收）企业所得税月（季）度申报',
        sbqx: staticConfig.finishDeadline,
        status: status,
      },
    ];
  } else if (taxQuestionType.value == 1) {
    tableData.value = [
      {
        id: 'e7c2a427da26465cbbc243e0e488fe2f',
        sqbzl: '增值税及附加税费申报(小规模纳税人适用)',
        sbqx: staticConfig.finishDeadline,
        status: status,
      },
    ];
  }else if (taxQuestionType.value == 4) { // 印花税
    tableData.value = [
      {
        id: 'e7c2a427da26465cbbc243e0e488fe2f',
        sqbzl: '财产和行为税税源采集及合并申报',
        sbqx: staticConfig.finishDeadline,
        status: status,
      },
    ];
  } else if (taxQuestionType.value == 5) { // 财务报表报送（季度）（一般纳税人）
    tableData.value = [
      {
        id: 'e7c2a427da26465cbaa243e0e488fe2f',
        sqbzl: props.currentQa.sonQueType == '27' ? '财务报表报送（季度）（一般纳税人）' : '财务报表报送（季度）（小规模纳税人）',
        sbqx: staticConfig.finishDeadline,
        status: status,
      },
    ];
  } else if (taxQuestionType.value == 29) { // 汇算清缴-财务报表报送
    tableData.value = [
      {
        id: 'e7c2a427da26465jkyi243e0e488fe2f',
        sqbzl: '财务报表报送（年报）- 小企业会计准则',
        sbqx: staticConfig.finishDeadline,
        status: status,
      },
    ];
  } else if (taxQuestionType.value == 201) { // 汇算清缴-企业所得税年度申报
    tableData.value = [
      {
        id: 'e7c2a427da26478jkyi243e0e488fe2f',
        sqbzl: '居民企业（查账征收）企业所得税年度申报',
        sbqx: staticConfig.finishDeadline,
        status: status,
      },
    ];
  }
});

const activeName1 = ref('first');
const activeName2 = ref('first');

const slides1 = ref(0);

const data = reactive([
  {
    title: '简易确认式申报',
    icon: 'cs-83001',
  },
  {
    title: '增值税及附加税费申报（一般...',
    icon: 'cs-20006',
  },
  {
    title: '税费缴纳',
    icon: 'cs-20120-back',
  },
  {
    title: '蓝字发票开具',
    icon: 'cs-5201',
  },
  {
    title: '居民企业（查账征收）企业所...',
    icon: 'cs-20051',
  },
  {
    title: '财务报表报送及更正',
    icon: 'cs-20113',
  },
  {
    title: '财产和行为税税源采集及合并...',
    icon: 'cs-10001',
  },
  {
    title: '红字发票功能',
    icon: 'cs-5202',
  },
  {
    title: '税务数字账户',
    icon: 'cs-4007',
  },
  {
    title: '增值税留抵税额退税',
    icon: 'cs-20013',
  },
]);

function fn(data) {
  return new URL(`https://static.rhkj.com/renhe_fe/other/reportTax/${data}.png`);
}

function startFill() {
  if ([1, 2, 3, 5, 29].includes(taxQuestionType.value)) { // 原报税题
    emit('startFill');
    return
  }

  if (taxQuestionType.value == 4) {  //印花税
    emit('yhs');
  }

  if (taxQuestionType.value == 201) {  //汇算清缴-企业所得税年度申报
    ElMessageBox.confirm("根据企业的经营情况，推荐您使用“简易确认式”申报功能，只需确认或调整少量信息就能完成多个税费申报。", "温馨提示", {
      confirmButtonText: "简单确认式申报",
      cancelButtonText: "忽略",
      type: "warning",
      distinguishCancelAndClose: true,
    })
        .then(() => {
          ElMessageBox.alert('教学专用，暂未开发', " ", {})
        })
        .catch(action => {
          if (action == 'cancel') {
            emit('startFill');
          }
        });
  }
}
</script>

<style scoped lang="scss">
.sub-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 100vh;
  font-size: 16px;
  background-color: #f7f8fa;
  display: flex;
  flex-direction: column;

  .header-box {
    position: relative;
    .top {
      height: 56px;
      background-image: url(https://static.rhkj.com/renhe_fe/other/316.png);
      background-size: cover;
    }

    .opera {
      position: absolute;
      left: 0;
      bottom: 0;
      right: 0;
      top: 0;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding-top: 3px;
      .menu-list {
        display: flex;
        margin-left: 370px;
        color: #FFFFFF;
        > li {
          margin-left: 20px;
          font-size: 12px;
          cursor: pointer;
          flex-shrink: 0;
        }
      }
      .grow {
        flex-grow: 1;
      }
    }

    .right-icon {
      width: 40px;
      height: 40px;
      margin-right: 60px;
      background: #b4d4fa;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
  }

  .page-content {
    flex: auto;
    width: 100%;
    height: 100%;
    overflow-y: auto;

    .page-wrap {
      width: 1184px;
      margin: 16px auto;
      border-radius: 2px;
      display: flex;
      flex-direction: column;
      row-gap: 16px;

      .show-shadow {
        background-color: #fff !important;
        border-radius: 2px !important;
        box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.06) !important;
      }

      .main-box {
        width: inherit;
        display: inline-flex;
        column-gap: 16px;
        -webkit-box-pack: justify;
        justify-content: space-between;

        .left-main {
          flex: none;
          width: 384px;
          display: inline-flex;
          flex-direction: column;
          row-gap: 16px;

          .left-top {
            box-sizing: border-box;
            width: inherit;
            padding: 19px 23px 13px 24px;

            .atext1 {
              color: #fff;
              background: #17b175;
              display: inline-block;
              width: 28px;
              height: 36px;
              font-size: 24px;
              line-height: 36px;
              text-align: center;
              border-radius: 2px 0 0 2px;
            }

            .atext2 {
              color: #2dac6e;
              background: #ebf8f2;
              display: inline-block;
              width: 72px;
              height: 36px;
              padding: 0 8px;
              font-size: 12px;
              font-weight: 400;
              line-height: 36px;
              border-radius: 0 2px 2px 0;
            }
          }

          .left-bottom {
            box-sizing: border-box;
            width: 100%;
            height: 260px;
            padding: 0 24px;

            .list-head {
              height: 64px;
              margin-bottom: 8px;
              line-height: 64px;
              vertical-align: middle;
              border-bottom: 1px solid rgba(39, 40, 46, 0.08);
            }
          }
        }

        .right-main {
          flex: auto;
          box-sizing: border-box;
          padding: 20px;
          background: #fff;
          border-radius: 2px;
          -webkit-box-shadow: rgba(0, 0, 0, 0.06) 0 2px 6px 0;
          box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.06);

          :deep(.el-tabs) {
            .el-tabs__nav {
              float: right;
            }
          }
        }
      }

      .collection-box {
        width: 100%;
        height: 233px;
        .collection-content {
          width: 100%;
          background: #fff;
          box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
          :deep(.el-tabs) {
            .el-tabs__header {
              padding: 0 24px;
            }

            .el-tabs__content {
              height: 165px;
            }
          }
          .main {
            position: absolute;
            top: 0;
            left: 0;
            width: max-content;
            overflow: hidden;
            margin-top: 16px;
            transition: all 0.5s;

            .item:first-child {
              margin-left: 38px !important;
            }

            .item:nth-child(8n + 1) {
              margin-left: 76px;
            }
            .item {
              width: 128px;
              height: 128px;
              margin-bottom: 16px;
              margin-left: 12px;
              color: #333;
              background-color: #fff;
              border-radius: 1px;
              float: left;
              cursor: pointer;

              &:hover {
                color: #649cf5;
              }
              .item-content {
                font-size: 12px !important;
                font-weight: 500;
                letter-spacing: 0;
                text-align: center;
                .item-img-box {
                  width: 100%;
                  margin-top: 19px;
                  pointer-events: none;

                  > img {
                    width: 58px;
                    height: 56px;
                    object-fit: contain;
                  }
                }
              }
              .item-info {
                display: table-cell;
                width: 128px;
                height: 32px;
                padding: 0 10px;
                font-size: 12px;
                line-height: 16px;
                text-align: center;
                vertical-align: middle;
              }
            }
          }
          .leftbtn {
            position: absolute;
            top: 67px;
            left: 15px;
            color: #d8d8d8;
            cursor: pointer;

            &:hover {
              color: #649cf5;
            }

            i {
              width: 32px;
              height: 32px;
              font-size: 32px;
              display: inline-block;
              vertical-align: middle;
            }
          }
          .rightbtn {
            position: absolute;
            top: 67px;
            right: 15px;
            color: #d8d8d8;
            cursor: pointer;

            &:hover {
              color: #649cf5;
            }

            i {
              width: 32px;
              height: 32px;
              font-size: 32px;
              display: inline-block;
              vertical-align: middle;
            }
          }
        }
      }

      .cjbs-box {
        width: 100%;
        height: 210px;
        background: #fff url('https://static.rhkj.com/renhe_fe/other/reportTax/cjbs.png') no-repeat top / 100% 100%;
        box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
        cursor: pointer;
      }

      .digital-box {
        width: 100%;
        height: 221px;
        background: #fff url('https://static.rhkj.com/renhe_fe/other/reportTax/digital.png') no-repeat top / 100% 100%;
        box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
        cursor: pointer;
      }

      .declaration-box {
        width: 100%;
        height: 400px;
        background: #fff url('https://static.rhkj.com/renhe_fe/other/reportTax/declaration.png') no-repeat top / 100% 100%;
        box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
        cursor: pointer;
      }

      .delated-box {
        width: 100%;
        height: 146.8px;
        background: #fff url('https://static.rhkj.com/renhe_fe/other/reportTax/delated.png') no-repeat top / 100% 100%;
        box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
        cursor: pointer;
      }
    }

    .index-footer-box {
      width: 100%;
      margin-top: 20px;
      background-color: #f1f2f3;

      .copyright {
        width: 1184px;
        padding: 21px 0;
        background: #f1f2f3;
        margin: 0 auto;
      }
    }
  }
}
</style>
